module.exports = __webpack_public_path__ + "static/media/ellipse.ad8582b4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ellipse.svg
 ** module id = 429
 ** module chunks = 0
 **/